<h1 mat-dialog-title>Update Product Data File Convention</h1>
<mat-dialog-content class="dialog-body">
  <app-product-data-filename-convention-form
    [initialValue]="seedValue"
    (formValue)="onFormValue($event)"
    (formValid)="onFormValid($event)"
  ></app-product-data-filename-convention-form>

  <section class="reason-section">
    <h3 class="reason-title">Reason for change</h3>
    <mat-button-toggle-group
      class="reason-group"
      aria-label="Reason for change"
      [formControl]="reasonControl"
    >
      @for (kind of selectableReasons; track kind) {
        <mat-button-toggle [value]="kind">{{ reasonLabel(kind) }}</mat-button-toggle>
      }
    </mat-button-toggle-group>

    @if (isOther) {
      <mat-form-field appearance="outline" class="detail-field">
        <mat-label>Detail</mat-label>
        <input
          matInput
          type="text"
          [formControl]="detailControl"
          placeholder="e.g. audit trail cleanup"
        />
        @if (detailControl.hasError('required') && detailControl.touched) {
          <mat-error>Detail is required when Reason is Other.</mat-error>
        }
        @if (detailControl.hasError('pattern') && !detailControl.hasError('required')) {
          <mat-error>Detail must contain at least 3 alphabetic characters.</mat-error>
        }
      </mat-form-field>
    }
  </section>
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-stroked-button
    type="button"
    color="buttonSuccess"
    class="save"
    [disabled]="!canSave"
    (click)="save()"
  >
    Save
  </button>
</mat-dialog-actions>
